export const sendNativeAppMessage = (message: NativeAppMessageSendData) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.ReactNativeWebView.postMessage(JSON.stringify(message))
}
